import React from "react";
import "./Certificate.css"; 
import ktc from './images/ktc.png'
import ktc_cer from './images/ktc cer.png'
import { QRCode } from "react-qrcode-logo"
import { useState, useEffect } from "react";
import { API_URL, ENDPOINTS, postData } from "../../constants/api";
import { useParams } from "react-router-dom";

const Certificate = () => {
  const { certificate_id } = useParams();
  const [certificateData, setCertificateData] = useState([]);
  const certificateLink = `https://newktc.kaafi.net/certificate/${certificate_id}`;

  useEffect(() => {
    const getCertificateData = async () => {
      const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/certificate-prints`;
      const body = { certificate_id };
      const response = await postData(url, body);
      setCertificateData(response.data);
    };
    getCertificateData();
  }, [certificate_id]);
  return (
    <div className="print-scope" >
    <div id="print-area" className="container background-image">
      <div className="row h-100">
        <div className="col text-center " >

          <div style={{ marginTop: "30px" }} />
          <img src={ktc} style={{ maxHeight: "100px" }} alt="Logo" />

          <div style={{ marginTop: "30px",paddingTop:'25px' }} />

          <p className="h4 fw-bold">
            By the Authority of Academic Board of Kaafiye Technology Center
          </p>

          <div style={{ marginTop: "30px" ,paddingTop:'25px'}} />

          <p className="h2 fw-bold">
            {certificateData[0]?.diploma}
          </p>

          <div style={{ marginTop: "30px",paddingTop:'35px' }} />

          <p className="h3 ">has been awarded to</p>

          <div style={{ marginTop: "20px" }} />

          <p className="h1 fw-bold">
            {certificateData[0]?.student_name}
          </p>

          <div  style={{paddingTop:'35px'}} />

          <p className="h4 fw-bold ">
            who has successfully completed the Diploma requirements
          </p>

          <div/>

          <p className="h3 fw-bold"   style={{marginTop:'35px'}}>
            from {certificateData[0]?.from} to {certificateData[0]?.to}
          </p>

          <div  style={{marginTop:'35px'}}/>

          <p className="h2 fw-bold" >
            The degree was approved by on {certificateData[0]?.approved_date}
          </p>

          <div style={{ marginTop: "40px" }} />

          <div className="row align-items-center">
            <div className="col-5 text-center">
              <div className="border border-dark"></div>
              <div style={{ paddingTop: "15px" ,}} />
              <p className="h5 fw-bold">Chief Executive Officer</p>
              <p className="h5 fw-bold">Eng. Zakariye Yusuf Hussein</p>
            </div>

            <div className="col-2 text-center">
              <img src={ktc_cer} style={{ maxHeight: "120px" }} alt="Stamp" />
            </div>

            <div className="col-5 text-center">
              <div className="border border-dark"></div>
              <div style={{ marginTop: "15px" }} />
              <p className="h5 fw-bold">Chief of Training Officer</p>
              <p className="h5 fw-bold">Dr. Mohamed Adam Isak</p>
            </div>
          </div>

          <div  />

          <div >
            <QRCode value={certificateLink} size={110} level="H" includeMargin />
            <p className="fw-bold">Certificate NO: {certificate_id}</p>
          </div>

        </div>
      </div>
    </div>
    </div>
  );
};

export default Certificate;
